import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, injectIntl } from "react-intl";
import Select from 'react-select';
import GlobalHelper from "../common/GlobalHelper";
import { integrationKeyRainforest } from "../integration/IntegrationConstants";

const messages = defineMessages({
    "all_options": {
        id: 'common.location.select.all_options',
        defaultMessage: 'All locations',
    },
})

class LocationSelect extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            optionForAll: this.props.optionForAll || false,
            valueForAll: this.props.valueForAll === undefined ? 'all' : this.props.valueForAll,
            selectedOption: this.props.value || '',
            fullAddressStringAsLabel: this.props.fullAddressStringAsLabel || false,
            integrationEnabled: this.props.integrationEnabled || false
        }
        this.multi = this.props.multi
        const defaultCallback = () => { }
        this.name = this.props.name
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }


    componentDidMount() {
        AppContext.getApiClient().get('/locations').then(r => {
            r.data = r.data.filter(loc => loc.attributes.enabled)
            if(this.state.integrationEnabled) {
                r.data = r.data.filter(loc => GlobalHelper.isLocationAvailable(loc.id, integrationKeyRainforest))
            }
            let data = []
            if (this.state.optionForAll) {
                data.push({
                    value: this.state.valueForAll,
                    label: this.props.intl.formatMessage(messages.all_options)
                })
            }
            data = data.concat(r.data.map(t => {
                let fullAddress = t.attributes.organization.attributes.address.formattedAddressString
                return {
                    value: t.id,
                    label: !this.state.fullAddressStringAsLabel ? t.attributes.name : fullAddress,
                }
            }))
            this.setState({
                options: data,
            })
        })
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            if (selectedOption && this.multi) {
                this.onChange(selectedOption.map(option => { return option.value }), selectedOption.map(option => { return option.label }).join(','))
            } else if (selectedOption) {
                this.onChange(selectedOption.value, selectedOption.label)
            } else {
                this.onChange('', '')
            }
        });
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || ''
            })
        }
    }

    render() {

        return (
            <Select
                name={this.name}
                multi={this.multi}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
            />
        )
    }
}

export default injectIntl(LocationSelect)





// WEBPACK FOOTER //
// ./src/location/locationselect.component.jsx